/* eslint-disable no-param-reassign */
export const applyBulkMasterFieldPatch = (entity, data) => {
  if (!entity || !data) return entity;

  const { meta, ...rest } = data;
  const next = { ...entity, ...rest };

  if (meta) {
    next.meta = { ...(entity.meta || {}), ...meta };
  }

  return next;
};

const collectExcludedIds = (summary = {}) => {
  const excluded = new Set();

  [...(summary.skipped || []), ...(summary.failed || [])].forEach((item) => {
    if (item?.id) excluded.add(String(item.id));
  });

  return excluded;
};

const toIdSet = (ids, excluded) => new Set(
  (ids || []).filter((id) => id && !excluded.has(String(id))).map(String),
);

const patchList = (list, productIdSet, variantIdSet, data) => {
  if (!list?.length) return;

  list.forEach((product, index) => {
    if (productIdSet.has(String(product._id))) {
      list[index] = applyBulkMasterFieldPatch(product, data);
    }

    const current = list[index];
    if (!variantIdSet.size || !current.variants?.length) return;

    current.variants = current.variants.map((variant) => (
      variantIdSet.has(String(variant._id))
        ? applyBulkMasterFieldPatch(variant, data)
        : variant
    ));
  });
};

export const applyBulkMasterFieldPatchToItems = (state, payload) => {
  if (!payload?.data || payload.ignored) return;
  if (payload.summary?.updated === 0) return;

  const excluded = collectExcludedIds(payload.summary);
  const productIdSet = toIdSet(payload.productIds, excluded);
  const variantIdSet = toIdSet(payload.variantIds, excluded);

  if (!productIdSet.size && !variantIdSet.size) return;

  patchList(state.items, productIdSet, variantIdSet, payload.data);
  patchList(state.search?.items, productIdSet, variantIdSet, payload.data);
};

export const applyBulkDraftFieldPatchToEntities = (state, payload) => {
  if (!payload?.data || payload.ignored) return;
  if (payload.summary?.updated === 0) return;

  const listings = state.entities?.listings;
  const listingVariants = state.entities?.listingVariants;
  if (!listings && !listingVariants) return;

  const excluded = collectExcludedIds(payload.summary);
  const listingIdSet = new Set(
    (payload.listingIds || []).filter((id) => id && !excluded.has(String(id))).map(String),
  );
  const variantIdSet = new Set(
    (payload.variantIds || []).filter((id) => id && !excluded.has(String(id))).map(String),
  );

  if (listings) {
    listingIdSet.forEach((listingId) => {
      const listing = listings[listingId];
      if (listing) listings[listingId] = applyBulkMasterFieldPatch(listing, payload.data);
    });
  }

  if (listingVariants) {
    variantIdSet.forEach((variantId) => {
      const variant = listingVariants[variantId];
      if (variant) {
        listingVariants[variantId] = applyBulkMasterFieldPatch(variant, payload.data);
      }
    });
  }
};
